module.exports = __webpack_public_path__ + "static/media/userMainColor.a8c5028a.png";